export enum LayoutIntentType {
    SuperGrid = 'SuperGrid',
    CssGrid = 'CssGrid',
    Mesh = 'Mesh'
}

export enum DomOrderStrategy {
    NShape = 'N-shape',
    ZShape = 'Z-shape'
}

export enum DockingBehavior {
    Heuristic = 'heuristic',
    Keep = 'keep'
}

export enum SizingBehavior {
    Preset = 'preset',
    Advanced = 'advanced'
}

export enum ProgressStatus {
    Unknown = 'UNKNOWN',
    ToDo = 'TO_DO',
    InProgress = 'IN_PROGRESS',
    Iterate = 'ITERATE',
    Done = 'DONE'
}

export interface EditorSettings {
    dockingBehavior?: DockingBehavior
    layoutIntent?: LayoutIntentType
    sizingBehavior?: SizingBehavior
    aspectRatioLock?: boolean
    disableAutoDOMOrder?: boolean
    domOrderStrategy?: DomOrderStrategy
    thumbnailId?: string
    progressStatus?: ProgressStatus
    linkedComponents?: Record<string, string>
}
